export const getPublishedTemplateRecord = (store, templateId, location) => {
  const variables = {};
  const sort = location.query.sort || "";
  if (sort) {
    variables.sort = sort;
  }
  const adoptedStore = store
    .getRoot()
    .getLinkedRecord("adoptedSystemDocumentTemplates", variables);
  if (!adoptedStore) {
    return;
  }

  return adoptedStore.getLinkedRecord("adoptedSystemDocumentTemplates");
};
